import React from "react"
import Classnames from "classnames";
import "./style.scss"

interface TitleProps {
  title: string;
  isMobile: boolean;
}

export default function Title ({ title, isMobile } : TitleProps) {
  const titleSplitByLegend = title.split("{}")
  return (
    <div
      className={Classnames("graph-title", {
        short: title.length > (isMobile ? 90 : 200),
      })}
    >
      {titleSplitByLegend.map((d, i) => 
        <span 
          key={i}
          className={Classnames({
            "legend-text": i == 0,
            "legend-dot": i > 0
          })}
          >{d}</span>
      )}
    </div>
  )
}